/*------------------------------------------------
// File Name:PDM_BANNER.js
// File Description:PDM_BANNER API方法js接口
// Author:zxl
// Create Time:2022/08/30 15:17:48
//------------------------------------------------*/
import { axios } from '@/utils/request'

const api = {
   _banner: "/PDM_BANNER"
}

export default api


//-------------------创建对象-------------------
export function CreatePDM_BANNEREntity(parameter) {
    return axios({
        url: api._banner + "/CreatePDM_BANNEREntity",
        method: 'post',
        data: parameter
    })
}

//-------------------获取列表-------------------
export function GetPDM_BANNERList(parameter) {
    return axios({
        url: api._banner + "/GetPDM_BANNERList",
        method: 'post',
        data: parameter
    })
}

//-------------------分页获取列表---------------
export function GetPDM_BANNERListByPage(parameter) {
    return axios({
        url: api._banner + "/GetPDM_BANNERListByPage",
        method: 'post',
        data: parameter
    })
}

//-------------------获取对象---------------
export function GetPDM_BANNEREntity(parameter) {
    return axios({
        url: api._banner + "/GetPDM_BANNEREntity",
        method: 'post',
        data: parameter
    })
}


//-------------------保存对象---------------
export function UpdatePDM_BANNEREntity(parameter) {
    return axios({
        url: api._banner+ "/UpdatePDM_BANNEREntity",
        method: 'post',
        data: parameter
    })
}

//-------------------删掉对象---------------
export function DeletePDM_BANNEREntity(parameter) {
    return axios({
        url: api._banner + "/DeletePDM_BANNEREntity",
        method: 'post',
        data: parameter
    })
}
